import { DownloadIcon } from '@rsos/assets/icons';
import { type Conversation } from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { SESSION_TYPE_LABELS } from '../../../../constants';
import {
  convertMillSecToMin,
  convertMillSecToDay,
  customUnixTimestamp,
  formatUnitValue,
} from '../../../../utils/helpers';
import styles from './ConversationTable.module.scss';

interface ConversationRowProps {
  conversation: Conversation;
  isChecked: boolean;
  onCheck: (id: string) => void;
  onDownload: (ids: string[]) => void;
  isDownloading: boolean;
}

const ConversationRow = ({
  conversation: d,
  isChecked,
  onCheck,
  onDownload,
  isDownloading,
}: ConversationRowProps) => {
  const remainingDays =
    d.time_until_expiration != null
      ? convertMillSecToDay(d.time_until_expiration)
      : null;
  const duration = d.duration != null ? convertMillSecToMin(d.duration) : null;

  const sessionType = SESSION_TYPE_LABELS[d.session_type];

  const isInteragency = d.session_type === 'interagency';

  const highlightRemaining =
    remainingDays !== null && remainingDays < 4 && !isInteragency;

  return (
    <tr key={d.conversation_id} className={styles.tr}>
      <td className={styles.td}>
        <input
          type="checkbox"
          checked={isChecked}
          onChange={() => onCheck(d.conversation_id)}
        />
      </td>
      <td className={styles.td}>
        {formatInternationalPhoneNumberHuman(d.phone_number)}
      </td>
      <td className={styles.td}>
        {customUnixTimestamp(new Date(d.start_time).toISOString())}
      </td>
      <td className={styles.td}>{formatUnitValue(duration, 'Minute')}</td>
      <td className={styles.td}>{sessionType ?? d.session_type}</td>
      <td className={styles.td}>
        {d.status[0].toUpperCase() + d.status.slice(1)}
      </td>
      <td
        className={`${styles.td}${highlightRemaining ? ` ${styles.danger}` : ''}`}
      >
        {isInteragency ? 'N/A' : formatUnitValue(remainingDays, 'Day')}
      </td>
      <td className={`${styles.td} ${styles.tdAction}`}>
        <button
          className={styles.rowDownloadBtn}
          onClick={() => onDownload([d.conversation_id])}
          disabled={isDownloading}
          data-tooltip="Download conversation"
        >
          <DownloadIcon width={24} height={24} />
        </button>
      </td>
    </tr>
  );
};

export default ConversationRow;
